function addQuery(location: string, query: { [s: string]: string }): string {
  if (!location) return '';
  let url = location;
  url += url.indexOf('?') === -1 ? '?' : '&';
  for (const [key, value] of Object.entries(query)) {
    url += `${key}=${encodeURIComponent(value)}&`;
  }
  return url.substr(0, url.length - 1);
}

export default addQuery;
